import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a Meta Pixel PageView event on every client-side route change.
 * The initial PageView is already fired from the pixel snippet in index.html,
 * so we skip the very first render to avoid a duplicate.
 */
export default function PixelTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.fbq !== "function") return;
    // Skip the initial render — index.html already fired the first PageView.
    if (window.__fbq_initial_skipped) {
      window.fbq("track", "PageView");
    } else {
      window.__fbq_initial_skipped = true;
    }
  }, [pathname, search]);

  return null;
}
